import React from 'react';
import { useColorMode, useColorModeValue, MenuItem, MenuItemProps } from '@chakra-ui/react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMoon, faSunBright } from '@fortawesome/pro-regular-svg-icons';

export const ColorModeSwitcher: React.FC<MenuItemProps> = props => {
  const { toggleColorMode } = useColorMode();
  const theme = useColorModeValue('Dark', 'Light');
  const switchIcon = useColorModeValue(faMoon, faSunBright);

  return (
    <MenuItem
      onClick={toggleColorMode}
      icon={<FontAwesomeIcon className="utility-icon" icon={switchIcon} size="lg" fixedWidth />}
      {...props}
    >
      {theme} mode
    </MenuItem>
  );
};
